module.exports = __webpack_public_path__ + "static/img/loading.3016b11.gif";


//////////////////
// WEBPACK FOOTER
// ./src/views/survey2/images/loading.gif
// module id = CzyP
// module chunks = 0